import SpecificErrorPage from "./SpecificErrorPage";

/**
 * Displays an error dialog for the 500 Internal Server Error.
 */
export default function Error() {
	return <SpecificErrorPage statusCode={"500"}/>
}
